<template>
  <base-layout>
    <template #default>
      <el-row class="main-div" ref="homeMain">
        <el-col>
          <!-- <diV
            style="color: red; opacity: 1;font-size: 1.25rem;background-color: pink;font-weight: bold;padding: 1rem 10%; word-break:break-all;"
          >
            {{ alterMsg }}</diV
          > -->
          <!--          <video  controls="controls"  name="media" preload="none"-->
          <!--                  width="100%"-->
          <!--                  x5-playsinline="true"-->
          <!--                  playsinline="true"-->
          <!--                  poster="/static/assets/video/home.jpg"-->
          <!--                  webkit-playsinline="true"-->
          <!--                  x-webkit-airplay="true"-->
          <!--                  muted="muted"-->
          <!--                  src="/static/assets/video/home.mp4" class="video-sm">-->
          <!--            <source src="/static/assets/video/home.ogg" type="video/ogg" />-->
          <!--            <source data-layzr-src="/static/assets/video/home.mp4" type="video/mp4">-->
          <!--            视频加载失败(西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所)-->
          <!--          </video>-->
        </el-col>
        <el-col class="home-problem" :style="homeProblemBG">
          <div class="home-problem-title">Seattle高端私人定制<br/>一对一的贴心服务</div>
          <div class="home-problem-info">
            <p>
              私家高级公寓 隐私安全
              环境温馨卫生  <br />
              ❤️高端定制❤️由桃桃私人会所安排❤️<br />
              车模，小明星，网红，洋妞 <br />
              留学生兼职，日本当红av女优 <br />
              韩国小模，按当天女孩条件等级定制价格
            </p>
            <p>
              直接电话☎️：<b class="phone-size">{{
                $store.state.contactConfig.phone2
              }}</b>
            </p>
            <b> ⚠️ 必读 ⚠️</b><br />
            各位大佬，为了让大家省时间跟方便，<br />
            在联系我之前请详细阅读须知与妹子内容.<br />
            <p>
              <b>请务必想好以下重点：</b> <br />
              1. 約多久？多少价位？（女友服务/莞式服务） <br />
              2. 约几点? <br />
              3. 约哪位? <br />
              4. 几位到？ <br />
              5.每个女生地址不同，请约定好再出发。<br />
              6.微信不聊隐私话题请打电话或者直接语音 <br />
              <b class="fontSize20">本店不支持转账！！！</b>
            </p>
          </div>
        </el-col>
        <!--  联系方式  -->
        <el-col class="home-contact">
          <div class="level-dimsum">
            <div class="box-card">
              <div slot="header" class="clearfix">
                <a
                  :href="'tel:' + $store.state.contactConfig.phone2"
                  class="telcolor"
                >
                  {{ $store.state.contactConfig.phone2 }} 来电预约
                  <i class="iconfont icon-a-dianhuazhichibangzhuzixun"></i>
                </a>
                <br />
                <br />
                <span class="servicetimewarp">营业时间：11:00 AM - 01:00 AM </span>
              </div>
              <tabsView></tabsView>
            </div>
            <div class="box-card home-map">
              <i class="iconfont icon-dingwei"></i>
              <span>地址：西雅图Bellevue</span>
            </div>
          </div>
        </el-col>
        <!--  甜心 -->
        <el-col class="home-princess">
          <div class="level-dimsum">
            <cardsView></cardsView>
          </div>
        </el-col>
        <!--  服务  -->
        <el-col class="home-service">
          <div class="level-dimsum">
            <h2>服务宗旨</h2>
            <div class="home-service-content">
              <div>❤ ＄300（45分钟）全套女友服务或莞式服务➕爱爱一次</div>
              <div>❤ ＄400（60分钟）全套女友服务或莞式服务➕爱爱一次</div>
              <div>❤ ＄500（60分钟）全套女友服务或莞式服务➕口一次➕爱爱一次(或爱爱两次)</div>
              <div>❤ $800（90分钟）顶级女友服务➕莞式服务➕无限次数  </div>
              <div>
                ❤ 部份日本Av女优 名模 网红 小明星 初下海学生妹 300/400/500/800/1200，
                外送价格起价（因人而异）800-2000 包夜2500-3500 包天伴游私聊
                （因人而异）提前预定时间 女友服务 亲密就像和女朋友感觉一样做爱
                谈情说爱 制服丝袜 各种捆绑游戏 眼罩 脚丝 kiss 69
                亲密无比，除了要戴t 和女朋友一样的感觉温暖你
                有细腻的感情交织在一起
              </div>
              <div>❤ 可双飞，3p，各种party，伴游包天包夜 （因人而异）</div>
              <div>
                <b>直接☎：{{ $store.state.contactConfig.phone2 }}</b>
              </div>
            </div>
          </div>
        </el-col>

      </el-row>
    </template>
    <template #footer></template>
  </base-layout>
</template>
<script>
import BaseLayout from "@/components/BaseLayout";
import tabsView from "@/components/mytabs";
import cardsView from "@/components/cardsView";  //partitionView
export default {
  name:'home',
  data() {
    return {
      msg: "index",
      autoplay: "autoplay",
      bgimg: "/static/assets/img/bg.jpg",
      homeProblemBG: {
        backgroundImage:
          "url(" + require("../../static/assets/img/bg2.jpg") + ")",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center"
      },
      alterMsg:"热烈庆祝西雅图桃桃会所周年庆为了回馈广大新老客户不断的给力支持2月20号-2月28号期间开启全场9折活动欢迎预约 谢谢"
    };
  },
  components: {
    BaseLayout,
    tabsView,
    cardsView
  },
};
</script>

<style scoped type="text/scss">
@media only screen and (max-width: 767px) {
  .level-dimsum {
    margin: auto;
  }
}

@media only screen and (min-width: 768px) {
  .level-dimsum {
    width: 1200px;
    margin: auto;
  }
}

/deep/ .el-footer {
  padding: 0 !important;
}

.box-card,
.home-contact{
  padding: 0.5rem;
  background-color: #1a1a1a;
}
.el-footer {
  padding: 0 !important;
}
/* home-problem */
i {
  font-size: 1.75rem;
}
.home-problem {
  color: white;
}
.home-problem-title {
  font-size: 2rem;
  font-weight: bold;
  padding-top: 1rem;
}
.home-problem-info {
  line-height: 30px;
  width: 100%;
  font-weight: bold;
  //background-image: linear-gradient(to bottom, #f09cab, #f787c9);
  background-image: linear-gradient(to bottom, #121212, #131313);
  opacity: 0.7;
}
.home-map img {
  padding-right: 1rem;
}
.home-map {
 padding: 0.5rem;
  color: #cfcfcf;
}

.el-tabs__item > span {
  display: flex;
  justify-content: space-between;
}
/* 服务宗旨 */
.home-service {
  //background-color: #f787c9;
  background-color: #121212;
  color: #cfcfcf;
  padding: 0px 10px;
}
.home-service-content {
  background-color: rgba(212,212,212,0.15);
  line-height: 36px;
}
/* princess */
.home-princess {
  padding: 0.01rem;
  background-color: #111111;
}
.phone-size {
  font-size: 26px;
}
</style>



// WEBPACK FOOTER //
// src/page/home.vue